import fyscalLogo from '@/assets/images/favicon-96x96.png';
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarTrigger,
	useSidebar,
} from '@/components/ui/sidebar';

export function TeamSwitcher() {
	const { state } = useSidebar();
	const isCollapsed = state === 'collapsed';

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<SidebarMenuButton
					render={<div />}
					size="lg"
					className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground cursor-auto"
				>
					<div>
						{!isCollapsed && (
							<div className="grid flex-1 text-left text-sm leading-tight">
								<img
									src={fyscalLogo}
									alt="Fyscal logo"
									loading="lazy"
									className="h-6 w-auto object-contain"
								/>
							</div>
						)}
						<SidebarTrigger
							className={isCollapsed ? 'text-white bg-black' : ''}
						/>
					</div>
				</SidebarMenuButton>
			</SidebarMenuItem>
		</SidebarMenu>
	);
}
